module.exports = __webpack_public_path__ + "img/sit_stand.2cf8088c.png";